import {Inject, Injectable, Injector, Renderer2, RendererFactory2} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {GlobalService} from 'app/global/global.service';
import { SessionImageService } from 'app/global/session-image.service';
import { DroplistOptions } from 'app/interfaces/fields';
import feather from 'feather-icons';
import uuid from 'short-unique-id';

@Injectable({
    providedIn: 'root',
})
export class Fields {
    private renderer:Renderer2
    public uuid = new uuid({ length: 6, dictionary: 'number' });
    constructor(@Inject(Injector) private readonly injector: Injector, private _translocoService:TranslocoService, private sessionImageService:SessionImageService, rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }
    /**
     * text field html append into ckeditor
     * @param params 
     */
    textFeildHtml(params: { uuid?:string, top?:string, left?:string } = {}) {
        return `<div style="top:${params.top}px;left:${params.left}px;" class="drag-fields text-field resize-e draggable content-draggable-field" uuid="${params.uuid}" field_required="1" field_fontsize="14">
                    <label class="recipient-role">${String(this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender")).substring(0,3).toLocaleUpperCase()}</label>
                    <div class="drag-fields-inner-container text-field-inner-container fields-ele-container">
                        <label class="field-style-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</label>
                        <input type="text" class="text-field-input field-label" placeholder="${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}">
                        <textarea class="hidden text-field-textarea" placeholder="${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}"></textarea>
                    </div>
                </div>`;
    }
    /**
     * checkbox field html append into ckeditor
     * @param params 
     */
    checkboxFeildHtml(params: { uuid?:string, top?:string, left?:string } = {}) {
        return `<div style="top:${params.top}px;left:${params.left}px;" class="drag-fields checkbox-field draggable content-draggable-field" uuid="${params.uuid}" field_required="1" field_fontsize="14">
                <label class="recipient-role">${String(this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender")).substring(0,3).toLocaleUpperCase()}</label>
                <div class="drag-fields-inner-container checkbox-field-inner-container fields-ele-container">
                    <div class="checkbox-field-box">
                        ${feather.icons.check.toSvg({ class: 'cursor-pointer checkbox-checkIcon', width: 14, height: 14 })}
                    </div>
                    <span class="field-label checkbox-field-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</span>
                </div>
            </div>
        `;
    }

    /**
     * checkbox field html append into ckeditor
     * @param params 
     */
    droplistFeildHtml(params: { uuid?:string, top?:string, left?:string } = {}) {
        const uuid = params.uuid;
        return `<div style="top:${params.top}px;left:${params.left}px;" class="drag-fields resize-e draggable droplist-field content-draggable-field" uuid="${uuid}" field_required="1" field_fontsize="14">
                <label class="recipient-role">${String(this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender")).substring(0,3).toLocaleUpperCase()}</label>
                <div class="drag-fields-inner-container droplist-field-inner-container droplist-menu fields-ele-container">
                    <span class="field-label selected-label selected-option-label" droplistplaceholder="${this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option")}">${this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option")}</span>
                    <ng-dropdown-panel role="listbox" aria-label="Options list" class="ng-dropdown-panel ng-select-bottom droplist-dropdown hidden">
                        <div class="ng-dropdown-panel-items scroll-host">
                            <div class="ng-dropdown-header hidden">
                                <input type="text" class="form-control w-100 search-drop-value" uuid="${uuid}">
                            </div>
                            <div class="ng-dropdown-custom-options"></div>
                        </div>
                    </ng-dropdown-panel>
                </div>
            </div>
        `;
    }

    /**
     * checkbox field html append into ckeditor
     * @param params 
     */
    datepickerFeildHtml(params: { uuid?:string, top?:string, left?: string } = {}) {
        return `<div style="top:${params.top}px;left:${params.left}px;" class="drag-fields resize-e draggable datepicker-field content-draggable-field" uuid="${params.uuid}" field_required="1" field_fontsize="14">
                <label class="recipient-role">${String(this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender")).substring(0,3).toLocaleUpperCase()}</label>
                <div class="drag-fields-inner-container datepicker-field-inner-container fields-ele-container">
                    <label class="field-style-label selected-label">${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}</label>
                    <input type="text" class="text-field-input field-label datepicker-field" placeholder="${this._translocoService.translate("Content new field (Template/Document - section) - Field name - New field")}">
                </div>
            </div>
        `;
    }


    /**
     * signature field html append into ckeditor
     * @param params 
     */
    signatureFeildHtml(params: { uuid?:string, top?:string, left?: string } = {}) {
        return `<div style="top:${params.top}px;left:${params.left}px;" class="drag-fields resize-se draggable signature-field content-draggable-field" uuid="${params.uuid}" field_required="1" field_fontsize="14">
                <label class="recipient-role">${String(this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender")).substring(0,3).toLocaleUpperCase()}</label>
                <div class="drag-fields-inner-container signature-field-inner-container fields-ele-container">
                    <span class="field-label selected-label cursor-pointer pe-auto hidden">${this._translocoService.translate("Content block html text on signature box (Template/Document - section) - Click to add your signature")}</span>
                    <div class="signature-image" style="background-image:url(});"></div>
                    <span class="assignee"></span>
                </div>
            </div>
        `;
    }

    /**
     * general popover for all fields
     * @param params 
     */
    fieldPopOver(params: { class?:string} = {}) {
        const fieldPopover = document.createElement('div');
        fieldPopover.className = `${params.class}-popover-container fieldsPopover fieldsSetting-popover-container`;
        fieldPopover.innerHTML = `
            ${feather.icons.sliders.toSvg({ class: 'cursor-pointer field_settings', width: 16, height: 16 })}
            ${feather.icons.trash.toSvg({ class: 'cursor-pointer remove_field', width: 16, height: 16 })}
        `;
        return fieldPopover;
    }

    /**
     * multi choice field html append into ckeditor
     * multiChoice-active
     * @param params 
     */
    multiChoiceFeildHtml(params: { uuid?:string, top?:string, left?: string, options? } = {}) {
        const uuid = params.uuid;
        let options = '';
        for (const option of params.options) {
            options += `
                    <div class="multiChoice-item" option_uuid="${option.id}">
                        <div class="multiChoice-box">
                            <div class="multiChoice-inner-circle"></div>
                            ${feather.icons.check.toSvg({ class: 'cursor-pointer multiChoice-inner-check', width: 14, height: 14 })}
                        </div>
                        <label class="multiChoice-label-text">${option.name}</label>
                    </div>`;
        }
        return `<div style="top:${params.top}px;left:${params.left}px;" class="drag-fields resize-e draggable multichoice-field multiChoice-radio content-draggable-field" uuid="${uuid}" field_required="1" field_fontsize="14">
                <label class="recipient-role">${String(this._translocoService.translate("Field setting sender text (Template/Document - section) - Sender")).substring(0,3).toLocaleUpperCase()}</label>
                <span class="field-label selected-label">${this._translocoService.translate("Content droplist select option (Template/Document - section) - Select option")}</span>
                <div class="multiChoice-item-container fields-ele-container">
                    ${options}
                </div>
            </div>
        `;
    }

    /**
     * singal multi choice field html append into ckeditor
     * multiChoice-active
     * @param params 
     */
    appendMultiChoiceField(params: { id?:string, name?:string, value?:string, meta_data_id?:number } = {}) {
        return `
            <div class="multiChoice-item" option_uuid="${params.id}">
                <div class="multiChoice-box">
                    <div class="multiChoice-inner-circle"></div>
                    ${feather.icons.check.toSvg({ class: 'cursor-pointer multiChoice-inner-check', width: 14, height: 14 })}
                </div>
                <label class="multiChoice-label-text">${params.name}</label>
            </div>`
    }

    /**
     * singal droplist field html append into ckeditor
     * multiChoice-active
     * @param params 
     */
    appendDroplistField(params: { id?:string, name?:string, value?:string, meta_data_id?:number  } = {}) {
        return `
            <div class="ng-option" option_uuid="${params.id}">
                <span class="ng-option-label">${params.name}</span>
            </div>`;
    }

    private get globalService() {
        return this.injector.get(GlobalService);
    }

    addPdfField(params: { type: string; uuid: string; pdfblock: HTMLElement; options: DroplistOptions[]; top: number; left: number }, callback:(uuid)=>void){
        const view = this.viewRoute(params.type, params);
        this.renderer.appendChild(params.pdfblock, this.fieldBlock(view));
        if (callback) {
            callback(params.uuid);
        }
    }

    fieldBlock(view: string): HTMLElement {
        const element = document.createElement('div')
        element.innerHTML = view;
        return element.firstChild as HTMLElement;
    }

        /**
     * return the view bsae on viewname
     * @param viewname
     * @param uuid
     * @param options
     */
    viewRoute(viewname: string, params) {
        let view = '';
        switch (viewname) {
            case 'text':
                view = this.textFeildHtml(params);
                break;
            case 'datepicker':
                view = this.datepickerFeildHtml(params);
                break;
            case 'checkbox':
                view = this.checkboxFeildHtml(params);
                break;
            case 'droplist':
                view = this.droplistFeildHtml(params);
                break;
            case 'multichoice':
                view = this.multiChoiceFeildHtml(params);
                break;
            case 'signature':
                view = this.signatureFeildHtml(params);
                break;
        }
        return view;
    }
}
